window.addEventListener( "DOMContentLoaded", () => {

	const bars = document.querySelectorAll( ".categories-bar" );

	if ( bars !== null ) {
		bars.forEach( elem => {

			// Event Listener
			elem.addEventListener( "click", ( e ) => {
				if ( e.target.nodeName !== "A" ) {
					return;
				}

				let href = e.target.getAttribute( "href" );

				if ( href.indexOf( "#" ) > -1 ) {
					e.preventDefault();

					elem.querySelectorAll( ".categories-bar__list-item" ).forEach( subElem => {
						subElem.classList.remove( "active" );
					} );

					e.target.parentNode.classList.add( "active" );

					let scrollTo = 0;

					if ( href.length > 1 ) {
						let element = document.querySelector( href );

						let headerHeight = 0;

						if ( window.innerWidth <= 768 ) {
							headerHeight = document.getElementById( "site-header" ).offsetHeight;
						}

						scrollTo = element.getBoundingClientRect().top + window.scrollY - 80 - headerHeight;
					}

					window.scrollTo( 0, scrollTo );
				}

			} );

			// Sticky bar
			if ( window.innerWidth <= 768 ) {
				// Stickyness
				const initialDistance = window.pageYOffset + elem.getBoundingClientRect().top;

				window.addEventListener( "scroll", e => {
					let scrollPosition = document.documentElement.scrollTop;

					let elemDistance = elem.getBoundingClientRect().top;
					let header = document.getElementById( "site-header" );
					let headerHeight = document.getElementById( "site-header" ).offsetHeight;

					if ( ! document.body.classList.contains( "home" ) ) {
						if ( elemDistance - headerHeight <= 0 ) {
							elem.dataset.sticky = "sticky";
							header.classList.add( "no-shadow" );
						} else if ( scrollPosition <= initialDistance ) {
							elem.dataset.sticky = "";
							header.classList.remove( "no-shadow" );
						}
					}

				} );
			}
		} );

	}

} );